// extracted by css-extract-rspack-plugin
export default {"AttendeesTable":"wDOxI","AttendeesTableWrapper":"jcMTK"};